export default function InCliniccon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M11.6663 1.89127V5.33338C11.6663 5.80009 11.6663 6.03345 11.7572 6.21171C11.8371 6.36851 11.9645 6.49599 12.1213 6.57589C12.2996 6.66672 12.533 6.66672 12.9997 6.66672H16.4418M13.333 10.8333H6.66634M13.333 14.1667H6.66634M8.33301 7.49999H6.66634M11.6663 1.66666H7.33301C5.93288 1.66666 5.23281 1.66666 4.69803 1.93914C4.22763 2.17882 3.84517 2.56128 3.60549 3.03168C3.33301 3.56646 3.33301 4.26653 3.33301 5.66666V14.3333C3.33301 15.7335 3.33301 16.4335 3.60549 16.9683C3.84517 17.4387 4.22763 17.8212 4.69803 18.0608C5.23281 18.3333 5.93288 18.3333 7.33301 18.3333H12.6663C14.0665 18.3333 14.7665 18.3333 15.3013 18.0608C15.7717 17.8212 16.1542 17.4387 16.3939 16.9683C16.6663 16.4335 16.6663 15.7335 16.6663 14.3333V6.66666L11.6663 1.66666Z"
        stroke="#EFE8DE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
